import ProductGrid from '../components/ProductGrid';

const HomePage = () => {
  return (
      <ProductGrid />
  );
};

export default HomePage;